import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaAward, FaRulerCombined, FaPalette, FaHandsHelping } from 'react-icons/fa';
import { motion } from 'framer-motion';
import ConsultationForm from './ConsultationForm';
import '../styles/About.css';

const AboutSection = () => {
  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6 } }
  };

  const features = [
    {
      icon: <FaAward className="feature-icon" />,
      title: "10+ Years Experience",
      description: "Proven track record of excellence"
    },
    {
      icon: <FaRulerCombined className="feature-icon" />,
      title: "Vastu Compliant",
      description: "Harmonious and balanced spaces"
    },
    {
      icon: <FaPalette className="feature-icon" />,
      title: "Custom Designs",
      description: "Tailored to your unique style"
    },
    {
      icon: <FaHandsHelping className="feature-icon" />,
      title: "End-to-End Service",
      description: "From concept to completion"
    }
  ];

  const [showContactForm, setShowContactForm] = useState(false);

  const handleContactForm = () => {
    setShowContactForm(true);
  };


  return (
    <section className="about-section">
      <div className="container">
        <motion.div
          className="about-grid"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          variants={container}
        >
          <motion.div className="about-content" variants={item}>
            <div className="section-header">
              <h2>About Astro Interiors</h2>
              <p>Creating spaces that inspire and transform</p>
              <p className="section-subtitle" style={{ color: 'var(--text-muted)' }}>
                Light-touch Vastu and zodiac cues available to harmonize your space—only if you want them.
              </p>
            </div>

            <motion.p className="about-text" variants={item}>
              With over a decade of experience in the interior design industry, Astro Interiors has been transforming spaces
              across the country. Our team of expert designers combines aesthetic appeal with functional design principles
              to create spaces that truly reflect your personality and lifestyle.
            </motion.p>

            <motion.div className="about-features" variants={container}>
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  className="feature"
                  variants={item}
                  whileHover={{ y: -5 }}
                >
                  {feature.icon}
                  <h4>{feature.title}</h4>
                  <p>{feature.description}</p>
                </motion.div>
              ))}
            </motion.div>

            <motion.div variants={item} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
              <button
                onClick={handleContactForm}
                className="btn btn-primary"
                style={{
                  background: 'linear-gradient(135deg, var(--primary-color), var(--primary-light))',
                  color: 'white',
                  border: 'none',
                  padding: '0.8rem 2rem',
                  borderRadius: '50px',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  fontWeight: 500,
                  textDecoration: 'none',
                  display: 'inline-block'
                }}
              >
                Get a Free Consultation
              </button>
            </motion.div>

            {showContactForm && (
              <ConsultationForm
                isOpen={showContactForm}
                onClose={() => setShowContactForm(false)}
                type="consultation"
              />
            )}
          </motion.div>

          <motion.div className="about-image" variants={item}>
            <img
              src="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1632&q=80"
              alt="Luxury interior design by Astro Interiors"
              loading="lazy"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutSection;
